import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.samples'),
    id: 'laboratorySamples',
    sidebar: [
        {
            id: 'sampleTypes',
            label: i18n.tc('configuration.sections.sampleType', 2),
            icon: 'far fa-prescription-bottle',
            routeName: 'LocalSampleTypes',
            hasChildren: false
        },
        {
            id: 'targetResponseTime',
            label: i18n.tc('configuration.sections.targetResponseTime', 2),
            icon: 'far fa-stopwatch',
            routeName: 'TargetResponseTime',
            hasChildren: false
        },
        {
            id: 'topographicSubsetLaboratory',
            label: i18n.tc('configuration.sections.topographicSubsetLaboratory', 2),
            icon: 'far fa-clipboard-list',
            routeName: 'TopographicSubsetLaboratory',
            hasChildren: false
        },
        {
            id: 'preformated',
            label: i18n.tc('configuration.sections.preformated', 2),
            icon: 'far fa-copy',
            routeName: 'Preformatted',
            hasChildren: false
        }
    ]
}
